import type { BlockType } from "@pathwright/blocks-core"
import { createContext, useContext } from "react"

const BlockEditorContext = createContext<{ isActive: boolean }>({ isActive: false })

export const useBlockEditorContext = () => useContext(BlockEditorContext)

const ALWAYS_EDITABLE_BLOCK_LAYOUTS = [
  "text_background" // Support use cases where designers add empty lines to achieve a specific cropping
]

// Simple provider that just passes through the isActive value
// No subscriptions to global state - each BlockEditor manages its own active state
export const BlockEditorContextProvider = ({
  children,
  isActive: propsIsActive,
  block
}: {
  children: React.ReactNode
  isActive: boolean
  block: BlockType
}) => {
  let isActive = propsIsActive
  const layout = block.layout

  // Omit specified block layouts from the offscreen optimization
  // that turns off QuillEditor and renders a noneditable BlockText component instead.
  // See blocks/shared/QuillEditor.tsx
  if (ALWAYS_EDITABLE_BLOCK_LAYOUTS.includes(layout)) {
    isActive = true
  }

  return (
    <BlockEditorContext.Provider value={{ isActive }}>
      {children}
    </BlockEditorContext.Provider>
  )
}
